import { css } from '@emotion/css'

import { breakpoint, colors, fontSize, fontWeight, mediaQueryHelper, spacing, accessiblyHidden } from '@offerzen/pinata-shame'

const styles = {
  container: css({
    padding: 0,
    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: `0 ${spacing.extraLarge}px ${spacing.extraLarge}px ${spacing.extraLarge}px ${spacing.extraLarge}px`,
    },
  }),

  imageContainer: css({
    display: 'flex',
    justifyContent: 'center',
    marginTop: spacing.medium,
    marginBottom: spacing.medium,
    minHeight: 29,

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginBottom: 0,
    },
  }),

  heading: css({
    fontSize: fontSize.large,
    marginTop: spacing.medium,
    marginBottom: spacing.large,
    textAlign: 'center',
    minHeight: 29,
  }),

  formContainer: css({
    backgroundColor: colors.white,
    padding: `${spacing.extraLarge}px ${spacing.large}px ${spacing.extraLarge}px ${spacing.large}px`,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginTop: `calc(${spacing.extraLarge}px + ${spacing.medium}px)`,
      borderRadius: 4,
      width: 474,
      padding: `${spacing.extraLarge}px ${spacing.extraLarge}px ${spacing.extraLarge}px ${spacing.extraLarge}px`,
    },
  }),

  label: css({
    fontSize: fontSize.small,
    color: colors.jumbo,
  }),

  inputContainer: css({
    marginBottom: spacing.large,
    '&:last-of-type': {
      marginBottom: spacing.default,
    },
  }),

  input: css({
    width: '100%',

    '& > small': {
      fontSize: fontSize.extraSmall,
      fontWeight: fontWeight.regular,
    },
  }),

  passwordContainer: css({
    display: 'flex',
    flexDirection: 'column',
  }),

  passwordToggleContainer: css({
    position: 'relative',
    display: 'inline-block',
  }),

  password: css({
    position: 'relative',
    '& > small': {
      fontSize: fontSize.extraSmall,
      fontWeight: fontWeight.regular,
    },
  }),

  imageToggleContainer: css({
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
  }),

  passwordSubtext: css({
    marginTop: spacing.extraSmall,
    fontSize: fontSize.extraSmall,
    fontWeight: fontWeight.regular,
  }),

  passwordError: css({
    color: colors.mandy,
  }),

  selectContainer: css({
    marginBottom: spacing.large,
    '& > div': {
      width: '100%',
    },
    small: {
      fontSize: fontSize.extraSmall,
      fontWeight: fontWeight.regular,
    },
  }),

  countryCodeInput: css({
    '& > div': {
      width: '100%',
    },
    '& > small': {
      fontSize: fontSize.extraSmall,
      fontWeight: fontWeight.regular,
    },
  }),

  checkboxContainer: css({
    alignItems: 'normal',
    '& > label': {
      margin: 0,
      marginLeft: spacing.default,
      marginBottom: spacing.default,
      color: colors.scorpion,
      fontSize: fontSize.small,
    },
    '& + small': {
      ...accessiblyHidden,
    },
  }),

  terms: css({
    fontSize: '80%',
  }),

  termsUrl: css({
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'underline',
    },
  }),

  submitContainer: css({
    marginTop: spacing.default,
    display: 'flex',
    justifyContent: 'center',
    marginBottom: spacing.large,
  }),

  submit: css({
    width: '100%',
  }),

  login: css({
    fontSize: fontSize.small,
    textAlign: 'center',
  }),
}

export default styles
